module.exports = __webpack_public_path__ + "img/zigbee.3f4dff48.jpg";